import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {User, UserId} from '../../../shared/models/user';
import {UsersService} from '../../../core/services/users.service';
import {SpinnerComponent} from '../spinner/spinner.component';
import {PillComponent} from '../pill/pill.component';
import {ShadeToolsService} from '../../../core/services/shade-tools.service';
import {DialogBoxButtonColor} from '../../../shared/models/dialog-box';

@Component({
  selector: 'motn-user-link',
  templateUrl: './user-link.component.html',
  styleUrls: ['./user-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SpinnerComponent,
    PillComponent,
  ],
})
export class UserLinkComponent implements OnInit, OnChanges {
  @Input() userId: UserId;
  @Input() user: User;
  @Input() showUsername: boolean = false;
  @Input() showMotionLogo: boolean = false;

  fetchFailed: boolean = false;

  @Output() fetchedUser$: EventEmitter<User> = new EventEmitter<User>();


  constructor(
    private usersService: UsersService,
    private shadeTools: ShadeToolsService,
  ) {
  }


  ngOnInit(): void {
    // this.fetchUser();
  }


  ngOnChanges() {
    this.fetchUser();
  }


  private fetchUser() {
    // If user is already provided, emit it and skip fetching
    if (this.user) {
      this.fetchedUser$.next(this.user);
      return;
    }

    this.fetchFailed = false;
    this.usersService.fetchUser$(this.userId).subscribe(
      (user) => {
        this.user = user;
        this.fetchedUser$.next(user);
      },
      () => {
        this.fetchFailed = true;
      },
    );
  }


  isMotionStaff(): boolean {
    return this.user?.Email?.endsWith('@motion.cloud') ?? false;
  }


  showMotionStaffInfo(): void {
    this.shadeTools.startDialog(
      'Motion Staff Member',
      'The Motion logo appears next to users who are staff members at Motion.',
      [{
        text: 'OK',
        callback: () => {},
        color: DialogBoxButtonColor.Default,
      }],
      false,
      false,
      false,
      true,
    );
  }
}
